import React from 'react'
import { graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import MetaTags from 'components/MetaTags'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import RoomPreview from 'components/RoomPreview'

import Heading from 'components/Heading'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'

import offersContent from 'content/offersContent.json'

const Offers = ({ data }) => {
  const intl = useIntl()
  const categories = offersContent[intl.locale] || []

  const {
    headerImage: {
      childImageSharp: { fluid },
    },
  } = data

  return (
    <Layout>
      <MetaTags
        title={`${intl.formatMessage({ id: 'ourOffers' })} | Hotel Griffintown`}
      />
      <Header
        eyebrow={intl.formatMessage({ id: 'ourOffers' })}
        heading={intl.formatMessage({ id: 'offer.heading' })}
        fluid={fluid}
      />

      {categories.map((cat) => {
        if (cat.uid === '__orphans__') return null
        if (cat.offers.length < 1) return null

        return (
          <Section key={cat.uid} id={cat.uid}>
            <Wrapper size='narrow'>
              <SectionBlock>
                <GridRow>
                  <GridItem xs='1-1' lg='3-4'>
                    <Heading
                      size={2}
                      variant='sans'
                      css={`
                        margin-bottom: 0.5em;
                      `}
                    >
                      {cat.title}
                    </Heading>

                    {cat.description ? <p>{cat.description}</p> : null}
                  </GridItem>
                </GridRow>
              </SectionBlock>
            </Wrapper>

            {cat.offers.map((offer, i) => (
              <Section key={offer.slug} flushTop={i % 2 !== 0}>
                <Wrapper>
                  <RoomPreview
                    name={offer.title}
                    description={offer.shortDescription}
                    to={`/offers/${offer.slug}`}
                    imageUrl={
                      (offer.imageUrl && String(offer.imageUrl).trim()) ||
                      offer.heroImageUrl ||
                      undefined
                    }
                    reverse={i % 2 === 0}
                    bookingUrl={offer.bookingUrl}
                    bookingTarget={offer.bookingTarget}
                  />
                </Wrapper>
              </Section>
            ))}
          </Section>
        )
      })}
    </Layout>
  )
}

export const query = graphql`
  query OffersPage {
    headerImage: file(name: { eq: "GH-2020-10-25_03288_RThibodeau" }) {
      childImageSharp {
        fluid(maxWidth: 2560, quality: 100, cropFocus: CENTER) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Offers
